module.exports = __webpack_public_path__ + "static/media/yaw_system.8a90fb5d.png";